import axios from 'axios'
import config from '../config'
import qs from 'qs';
import jwtDecode from 'jwt-decode'

export default {

    tokenDecode(token) {
        return jwtDecode(token);
    },
    getToken() {
        return localStorage.getItem('token');
    },
    getRefreshToken() {
        return localStorage.getItem('refresh_token');
    },
    setToken(token) {
        localStorage.setItem('token', token);
    },
    setRefreshToken(refreshToken) {
        localStorage.setItem('refresh_token', refreshToken);
    },
    setOnceGlobalToken(token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    rememberMe(rememberMe) {
        localStorage.setItem('rememberMe', rememberMe);
    },
    getRememberMe() {
        return localStorage.getItem('rememberMe');
    },
    async refreshToken() {
        return await axios.post(config.publicPath + 'token/refresh',
                { "refresh_token": this.getRefreshToken() },
                {
                    validateStatus: function (status) {
                        return status >= 200 && status <= 500;
                }
            })
            .then(response => {
                if (response.status !== 'undefined') {
                    if (response.status !== 200) {
                        return new Promise((resolve) => {
                            resolve(false);
                        });
                    }
                    this.setToken(response.data.token);
                    this.setRefreshToken(response.data.refresh_token);
                    return new Promise((resolve) => {
                        resolve(true);
                    });
                } else {
                    this.logOut();
                }
            });
    },
    singUp(data) {
        const options = {
            method: 'POST',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: qs.stringify(data),
            url: config.publicPath + 'register'
        };
        return axios(options);
    },
    signIn(credentials) {
        return axios.post(config.publicPath + 'login_check', credentials);
    },
    isAdmin() {
        if (!this.getToken()) {
            return {};
        }
        let user = this.tokenDecode(this.getToken());
        return user.roles.includes('ROLE_ADMIN')
    },
    isUser() {
        if (!this.getToken()) {
            return {};
        }
        let user = this.tokenDecode(this.getToken());
        return user.roles.includes('ROLE_USER')
    },
    logOut() {
        localStorage.clear();
    },
}
